import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6 1C3.2379 1 1 3.25806 1 6C1 8.7621 3.2379 11 6 11C8.74194 11 11 8.7621 11 6C11 3.25806 8.74194 1 6 1ZM6 10.0323C3.7621 10.0323 1.96774 8.2379 1.96774 6C1.96774 3.78226 3.7621 1.96774 6 1.96774C8.21774 1.96774 10.0323 3.78226 10.0323 6C10.0323 8.2379 8.21774 10.0323 6 10.0323ZM6 3.21774C5.51613 3.21774 5.15323 3.60081 5.15323 4.06452C5.15323 4.54839 5.51613 4.91129 6 4.91129C6.46371 4.91129 6.84677 4.54839 6.84677 4.06452C6.84677 3.60081 6.46371 3.21774 6 3.21774ZM7.12903 8.33871V7.85484C7.12903 7.73387 7.00806 7.6129 6.8871 7.6129H6.64516V5.59677C6.64516 5.47581 6.52419 5.35484 6.40323 5.35484H5.1129C4.97177 5.35484 4.87097 5.47581 4.87097 5.59677V6.08065C4.87097 6.22177 4.97177 6.32258 5.1129 6.32258H5.35484V7.6129H5.1129C4.97177 7.6129 4.87097 7.73387 4.87097 7.85484V8.33871C4.87097 8.47984 4.97177 8.58064 5.1129 8.58064H6.8871C7.00806 8.58064 7.12903 8.47984 7.12903 8.33871Z",
      fill: "#8B8B8B"
    }, null, -1)
  ]))]))
}
export default { render: render }